// The state must return a function
// to make the module reusable.
// See: https://vuex.vuejs.org/en/modules.html#module-reuse
const state = () => ({
  reloadContactTable: false,
});

const getters = {};

const mutations = {
  toggleEvent(state, event) {
    state[event] = ! state[event]
  }
};

const actions = {};

const EventsStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default EventsStore;
